// Bilingual dictionary for Jaytech landing page.
// Use: const t = translations[lang]
export const translations = {
  id: {
    nav: {
      about: "Tentang",
      services: "Layanan",
      whyUs: "Mengapa Kami",
      industries: "Industri",
      contact: "Kontak",
      cta: "Hubungi Kami",
    },
    hero: {
      eyebrow: "Transformasi Operasi Digital",
      title1: "Operasi enterprise yang ",
      title_accent: "terhubung",
      title2: ", terlihat, dan terkendali.",
      subtitle:
        "Jaytech membantu perusahaan meningkatkan efisiensi, visibilitas, dan kontrol operasional — bukan sekadar pengembangan software, tapi transformasi nyata di lantai operasi.",
      ctaPrimary: "Mulai Konsultasi",
      ctaSecondary: "Lihat Layanan",
      stat1: "40+ Klien Enterprise",
      stat2: "100+ Proyek Terimplementasi",
      stat3: "Multi-site & Multi-warehouse",
    },
    marquee: "Manufaktur • Logistik • Pergudangan • Distribusi • Operasi Multi-site • ERP • RFID • Automasi • IoT • ",
    about: {
      label: "TENTANG KAMI",
      title: "Kami memahami operasi nyata, bukan hanya teori sistem.",
      body1:
        "Jaytech Informatika Indonesia adalah mitra transformasi digital untuk perusahaan berskala enterprise di Indonesia. Fokus kami pada integrasi sistem yang menyatukan ERP, RFID, dashboard, dan operasional menjadi satu kesatuan yang dapat dipantau secara real-time.",
      body2:
        "Dari assessment awal hingga pemeliharaan jangka panjang, kami mendampingi penuh siklus implementasi — dirancang fleksibel agar tumbuh seiring kebutuhan bisnis Anda.",
      pill1: "Full-cycle implementation",
      pill2: "Enterprise integration",
      pill3: "Business-oriented",
    },
    services: {
      label: "LAYANAN",
      title: "Solusi operasional end-to-end untuk perusahaan enterprise.",
      subtitle:
        "Lima pilar layanan yang dirancang agar saling terintegrasi — bukan silo.",
      items: {
        erp: {
          tag: "ERP",
          title: "Implementasi ERP",
          desc: "Implementasi Odoo end-to-end: blueprint, konfigurasi modul, migrasi data, training, dan go-live yang terkendali.",
          bullets: ["Odoo Enterprise & Community", "Custom Module Development", "Data Migration & Training"],
        },
        rfid: {
          tag: "RFID",
          title: "RFID Asset Management",
          desc: "Pelacakan aset real-time dengan hardware Zebra & Chainway untuk gudang, manufaktur, dan distribusi.",
          bullets: ["Real-time Asset Tracking", "Fixed & Handheld Readers", "Warehouse & Plant Floor"],
        },
        custom: {
          tag: "CUSTOM DEV",
          title: "Enterprise Custom Development",
          desc: "Web, mobile, API, dashboard, dan integrasi IoT yang dirancang khusus untuk logika bisnis Anda.",
          bullets: ["Web & Mobile App", "API & System Integration", "Custom Portal & Dashboard"],
        },
        automation: {
          tag: "AI · RPA",
          title: "Workflow Automation",
          desc: "Eliminasi pekerjaan administratif berulang dengan AI reasoning dan RPA — dari ekstraksi dokumen hingga eksekusi otomatis.",
          bullets: ["Document Extraction", "Intelligent Processing", "Automated Execution"],
        },
        support: {
          tag: "OPS SUPPORT",
          title: "Operational Support",
          desc: "Monitoring sistem, preventive maintenance, infrastruktur, dan IT support yang reliable 24/7.",
          bullets: ["24/7 System Monitoring", "Preventive Maintenance", "Infrastructure Support"],
        },
      },
    },
    why: {
      label: "MENGAPA JAYTECH",
      title: "Lima alasan perusahaan enterprise memilih kami.",
      items: [
        {
          title: "Operational Understanding",
          desc: "Kami memahami implementasi di lapangan — bukan hanya teori sistem.",
        },
        {
          title: "Enterprise Integration",
          desc: "Menghubungkan ERP, RFID, dashboard, dan sistem operasional menjadi satu kesatuan.",
        },
        {
          title: "Full-Cycle Implementation",
          desc: "Mendampingi dari assessment awal hingga dukungan berkelanjutan.",
        },
        {
          title: "Flexible & Scalable",
          desc: "Solusi yang dirancang untuk tumbuh bersama kebutuhan bisnis Anda.",
        },
        {
          title: "Business-Oriented",
          desc: "Fokus pada dampak operasional dan visibilitas eksekutif, bukan sekadar teknologi.",
        },
      ],
    },
    stats: {
      label: "JEJAK KAMI",
      title: "Skala enterprise yang sudah kami percayakan.",
      items: [
        { value: 40, suffix: "+", label: "Klien Enterprise" },
        { value: 100, suffix: "+", label: "Proyek Terimplementasi" },
        { value: 4, suffix: "+", label: "Industri Strategis" },
        { value: 24, suffix: "/7", label: "Operational Support" },
      ],
    },
    industries: {
      label: "INDUSTRI",
      title: "Dipercaya lintas sektor operasional kritis.",
      items: ["Manufaktur", "Logistik", "Pergudangan", "Distribusi", "Multi-site Operations", "Enterprise Systems"],
    },
    contact: {
      label: "KONTAK",
      title: "Mari diskusikan transformasi operasi Anda.",
      subtitle:
        "Tim Jaytech akan merespons dalam 1–2 hari kerja. Ceritakan tantangan operasional Anda dan kami akan mengusulkan langkah pertama yang tepat.",
      info: {
        email: "Email",
        phone: "Telepon",
        web: "Website",
        address: "Wilayah Layanan",
        addressVal: "Indonesia · Enterprise nationwide",
      },
      form: {
        name: "Nama lengkap",
        company: "Perusahaan",
        email: "Email kerja",
        phone: "Nomor telepon",
        service: "Layanan yang diminati",
        servicePlaceholder: "Pilih layanan (opsional)",
        message: "Tantangan operasional Anda",
        messagePlaceholder: "Ceritakan singkat tujuan dan kondisi saat ini…",
        submit: "Kirim Pesan",
        submitting: "Mengirim…",
        successTitle: "Pesan terkirim",
        successDesc: "Terima kasih. Tim Jaytech akan menghubungi Anda segera.",
        errorTitle: "Gagal mengirim",
        errorDesc: "Mohon coba kembali atau email langsung ke info@jaytech.id.",
        required: "Wajib diisi",
        invalidEmail: "Format email tidak valid",
      },
    },
    footer: {
      tagline: "Transformasi Operasi Digital untuk perusahaan enterprise.",
      sections: {
        company: "Perusahaan",
        services: "Layanan",
        contact: "Kontak",
      },
      links: {
        about: "Tentang",
        why: "Mengapa Kami",
        industries: "Industri",
      },
      copy: "© {year} Jaytech Solutions. Semua hak dilindungi.",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      whyUs: "Why Us",
      industries: "Industries",
      contact: "Contact",
      cta: "Contact Us",
    },
    hero: {
      eyebrow: "Digital Operational Transformation",
      title1: "Enterprise operations that are ",
      title_accent: "connected",
      title2: ", visible, and in control.",
      subtitle:
        "Jaytech helps companies improve efficiency, visibility, and operational control — not just software development, but real transformation at the operations floor.",
      ctaPrimary: "Start a Consultation",
      ctaSecondary: "Explore Services",
      stat1: "40+ Enterprise Clients",
      stat2: "100+ Projects Delivered",
      stat3: "Multi-site & Multi-warehouse",
    },
    marquee: "Manufacturing • Logistics • Warehousing • Distribution • Multi-site Operations • ERP • RFID • Automation • IoT • ",
    about: {
      label: "ABOUT US",
      title: "We understand real operations, not just system theory.",
      body1:
        "Jaytech Informatika Indonesia is the digital transformation partner for enterprise-scale companies in Indonesia. We focus on system integration that unifies ERP, RFID, dashboards, and operational systems into one real-time, observable whole.",
      body2:
        "From initial assessment to long-term maintenance, we walk the full implementation cycle alongside you — designed to flex and scale as your business grows.",
      pill1: "Full-cycle implementation",
      pill2: "Enterprise integration",
      pill3: "Business-oriented",
    },
    services: {
      label: "SERVICES",
      title: "End-to-end operational solutions for the enterprise.",
      subtitle:
        "Five service pillars built to integrate with each other — never to silo.",
      items: {
        erp: {
          tag: "ERP",
          title: "ERP Implementation",
          desc: "End-to-end Odoo implementation: blueprinting, module configuration, data migration, training, and a controlled go-live.",
          bullets: ["Odoo Enterprise & Community", "Custom Module Development", "Data Migration & Training"],
        },
        rfid: {
          tag: "RFID",
          title: "RFID Asset Management",
          desc: "Real-time asset tracking with Zebra & Chainway hardware for warehousing, manufacturing, and distribution.",
          bullets: ["Real-time Asset Tracking", "Fixed & Handheld Readers", "Warehouse & Plant Floor"],
        },
        custom: {
          tag: "CUSTOM DEV",
          title: "Enterprise Custom Development",
          desc: "Web, mobile, APIs, dashboards, and IoT integrations engineered around your business logic.",
          bullets: ["Web & Mobile App", "API & System Integration", "Custom Portal & Dashboard"],
        },
        automation: {
          tag: "AI · RPA",
          title: "Workflow Automation",
          desc: "Eliminate repetitive admin work with AI reasoning and RPA — from document extraction to automated execution.",
          bullets: ["Document Extraction", "Intelligent Processing", "Automated Execution"],
        },
        support: {
          tag: "OPS SUPPORT",
          title: "Operational Support",
          desc: "System monitoring, preventive maintenance, infrastructure, and reliable 24/7 IT support.",
          bullets: ["24/7 System Monitoring", "Preventive Maintenance", "Infrastructure Support"],
        },
      },
    },
    why: {
      label: "WHY JAYTECH",
      title: "Five reasons enterprise companies choose us.",
      items: [
        {
          title: "Operational Understanding",
          desc: "We understand on-the-ground implementation — not just system theory.",
        },
        {
          title: "Enterprise Integration",
          desc: "Connecting ERP, RFID, dashboards, and operational systems into a single whole.",
        },
        {
          title: "Full-Cycle Implementation",
          desc: "We accompany you from initial assessment through ongoing support.",
        },
        {
          title: "Flexible & Scalable",
          desc: "Solutions designed to grow alongside your business needs.",
        },
        {
          title: "Business-Oriented",
          desc: "Focused on operational impact and executive visibility — not just technology.",
        },
      ],
    },
    stats: {
      label: "OUR TRACK RECORD",
      title: "Enterprise scale already entrusted to us.",
      items: [
        { value: 40, suffix: "+", label: "Enterprise Clients" },
        { value: 100, suffix: "+", label: "Projects Delivered" },
        { value: 4, suffix: "+", label: "Strategic Industries" },
        { value: 24, suffix: "/7", label: "Operational Support" },
      ],
    },
    industries: {
      label: "INDUSTRIES",
      title: "Trusted across mission-critical operations.",
      items: ["Manufacturing", "Logistics", "Warehousing", "Distribution", "Multi-site Operations", "Enterprise Systems"],
    },
    contact: {
      label: "CONTACT",
      title: "Let's discuss your operational transformation.",
      subtitle:
        "The Jaytech team will respond within 1–2 business days. Tell us about your operational challenge and we'll propose the right first step.",
      info: {
        email: "Email",
        phone: "Phone",
        web: "Website",
        address: "Service Area",
        addressVal: "Indonesia · Enterprise nationwide",
      },
      form: {
        name: "Full name",
        company: "Company",
        email: "Work email",
        phone: "Phone number",
        service: "Service of interest",
        servicePlaceholder: "Pick a service (optional)",
        message: "Your operational challenge",
        messagePlaceholder: "Briefly share the goal and current situation…",
        submit: "Send Message",
        submitting: "Sending…",
        successTitle: "Message sent",
        successDesc: "Thank you. The Jaytech team will reach out shortly.",
        errorTitle: "Sending failed",
        errorDesc: "Please try again or email info@jaytech.id directly.",
        required: "Required",
        invalidEmail: "Invalid email format",
      },
    },
    footer: {
      tagline: "Digital Operational Transformation for enterprise companies.",
      sections: {
        company: "Company",
        services: "Services",
        contact: "Contact",
      },
      links: {
        about: "About",
        why: "Why Us",
        industries: "Industries",
      },
      copy: "© {year} Jaytech Solutions. All rights reserved.",
    },
  },
};

export const SERVICE_OPTIONS = [
  { id: "erp", label_id: "Implementasi ERP (Odoo)", label_en: "ERP Implementation (Odoo)" },
  { id: "rfid", label_id: "RFID Asset Management", label_en: "RFID Asset Management" },
  { id: "custom", label_id: "Custom Development", label_en: "Custom Development" },
  { id: "automation", label_id: "AI & RPA Automation", label_en: "AI & RPA Automation" },
  { id: "support", label_id: "Operational Support", label_en: "Operational Support" },
  { id: "other", label_id: "Lainnya / Belum yakin", label_en: "Other / Not sure" },
];
